import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const FormField = ({ label, name, type, value, invalid, onChange, onFocus, onBlur }) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <div
            className={cx('rounded border transition', {
                'bg-white border-gray-20': !invalid && !isFocused,
                'bg-blue-10 border-blue-30': !invalid && isFocused,
                'bg-red-10 border-red-50': invalid,
            })}
        >
            <label
                htmlFor={name}
                css={{ cursor: 'text' }}
                className={cx('block relative px-4', {
                    'py-6': !value,
                    'pt-8 pb-3': !!value,
                })}
            >
                <span
                    css={{ marginTop: 2, marginLeft: 1 }}
                    className={cx(
                        'pointer-events-none absolute pin-t pin-l pl-4 leading-none transition block',
                        {
                            'text-18 pt-6': !value,
                            'text-11 pt-3': !!value,
                            'text-gray-40': !invalid,
                            'text-red-70': invalid,
                        }
                    )}
                >
                    {label}
                </span>
                <input
                    type={type}
                    name={name}
                    id={name}
                    className="text-18 text-gray-80 bg-transparent leading-none block w-full focus:outline-none"
                    value={value}
                    onChange={onChange}
                    onFocus={e => {
                        setIsFocused(true);
                        onFocus(e);
                    }}
                    onBlur={e => {
                        setIsFocused(false);
                        onBlur(e);
                    }}
                />
            </label>
        </div>
    );
};

FormField.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    value: PropTypes.string,
    type: PropTypes.string,
    invalid: PropTypes.bool,
};

FormField.defaultProps = {
    type: 'text',
    value: '',
    invalid: false,
    onFocus: () => {},
    onBlur: () => {},
};

export default FormField;
